export default __webpack_public_path__ + "/dist/images/cibecco-bg2.03a9358893a36307ac3d0279959352ad.svg";